import { render, staticRenderFns } from "./ProductOutflowDiameters.vue?vue&type=template&id=53f191e8&"
import script from "./ProductOutflowDiameters.vue?vue&type=script&lang=js&"
export * from "./ProductOutflowDiameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports